import React, { useEffect, useState } from "react";
import { Form, Button, Col, Row, InputGroup, Alert } from "react-bootstrap";
import styles from "./Login.module.css";
// import { Form, Button } from "react-bootstrap";
// import { FiEye, FiEyeOff } from "react-icons";
import { FiEye } from "react-icons/fi";
import { FiEyeOff } from "react-icons/fi";
import Oglogo from "../../assets/eprocurement.png"
import Build from "../../assets/building-2.svg";
import User from "../../assets/User.png";
import House from "../../assets/housee.svg";
import Stepper from "../../assets/stepper.svg";
import Stepper2 from "../../assets/step2.svg";
import svgIcon from "../../assets/VectorSpiral.png"
import { useNavigate } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import { MdArrowBack } from "react-icons/md";
import axios from "axios";
import { BASE_URL } from "../../Components/API/Api";

const ForgotPassword = () => {
 const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState("");
   const [currentStep, setCurrentStep] = useState(0);
   const [loading, setLoading] = useState(false);

  const togglePassword = () => {
    setShowPassword(prev => !prev);
   
  };

  const handleHome = () => {
  navigate("/");
};
  const handleRegister = () => {
  navigate("/login");
};

 
 const [businessType, setBusinessType] = useState("");

  const [cacNumber, setCacNumber] = useState("");
  const [email, setEmail] = useState("");

const handleNext = (e) => {
  e.preventDefault();
  setCurrentStep(1);
};

const handleBack = () => {
  
    navigate(-1); // go to previous screen

};
  const getCurrentYear = () => new Date().getFullYear();
  const [alert, setAlert] = useState({
    show: false,
    type: "", // success | danger
    message: "",
  });
  

const handleLogin = async (e) => {
  e?.preventDefault(); // prevents form refresh if used in form
  setLoading(true);
  setErrorMessage("");

  try {
    const response = await axios.post(`${BASE_URL}/forgot_password`, {
      email
      
    });

    // const user = response.data?.data?.user;
    // const company = response.data?.data?.company;
    // const registration = response.data?.data?.registration_alert;
    // const token = response.data?.data?.token;

    // if (!user || !token) {
    //   throw new Error("Invalid response from server");
    // }

    // // ✅ Save to localStorage
    // localStorage.setItem("userName", user.name);
    // localStorage.setItem("userEmail", user.email);
    // localStorage.setItem("userToken", token);
    // localStorage.setItem("companyApproved", company.approval_status);
    // localStorage.setItem("hasRegistered", registration.completion_percent);
   
    // 👉 redirect after login
    // navigate("/login");
    setAlert({
    show: true,
    type: "success",
    message: "Password reset link sent to your email.",
  });

   } catch (error) {
  let errorMsg = "An unexpected error occurred";

  const apiErrors = error?.response?.data?.data;

  if (apiErrors && typeof apiErrors === "object") {
    // get first field error only
    const firstKey = Object.keys(apiErrors)[0];
    if (firstKey && Array.isArray(apiErrors[firstKey])) {
      errorMsg = apiErrors[firstKey][0]; // first message only
    }
  } else if (typeof error?.response?.data?.message === "string") {
    errorMsg = error.response.data.message;
  } else if (error.message) {
    errorMsg = error.message;
  }

  setAlert({
    show: true,
    type: "danger",
    message: errorMsg,
  });
}
     finally {
    setLoading(false);
  }
};

useEffect(() => {
  if (alert.show) {
    const timer = setTimeout(() => {
      setAlert((prev) => ({ ...prev, show: false }));
    }, 4000);
    return () => clearTimeout(timer);
  }
}, [alert.show]);

  
  return (
    <div className={styles.wrapper}>
      {/* LEFT SIDE */}
      <div className={styles.left}>
        <div className={styles.logo} onClick={handleHome}>
        <img src={Oglogo} alt="logo" className={styles.imglogo} />
        </div>

        <div className={styles.leftContent}>
          <h1 className={styles.welcome}>Procurement</h1>
          <h1 className={styles.title}>
            <span className={styles.ogtxt}>Simplified &</span>
            <span className={styles.txtclor}> Transparent</span>
          </h1>

          <h4 className={styles.description}>
            Register your company to access Ogun State government procurement opportunities through a secure and transparent platform
          </h4>      
          <ul className={styles.listItems}>
  <li>CAC-verified suppliers only</li>
  <li>Secure bidding and contract awards</li>
  <li>Access to opportunities across Nigeria</li>
</ul>
 <img src={House} className={styles.houseIcon} />
        </div>

        {/* <p className={styles.footer}>
          © {getCurrentYear()} TABBACCI, LICENSED TO OGUN STATE INTERNAL REVENUE SERVICE
        </p> */}
      </div>

      {/* RIGHT SIDE */}
      <div className={styles.right}>
        <div className={styles.topCont}>
        <div className={styles.backIcons} onClick={handleBack}>
        <MdArrowBack style={{fontSize: 20, color: '#059669'}}/>
        <p className={styles.backtxt} >Go Back</p>
        </div>
       
        </div>

       <div className={styles.welcometxt}>
      <h1>Forgot Password</h1>
      <p>Don't worry – we'll help you reset your password. Just enter your email.</p>
</div>

{alert.show && (
  <Alert
    variant={alert.type}
    onClose={() => setAlert({ ...alert, show: false })}
    dismissible
  >
    {alert.message}
  </Alert>
)} 
        <div className={styles.formCard}>
          <Form>
 

  
    <Col md={12}>
      <Form.Group>
        <Form.Label className={styles.txtfom}>Email</Form.Label>
        <Form.Control
          type="email"
          placeholder="company@email.com"
          className={styles.txtfield}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </Form.Group>
    </Col>

    {/* <Col md={12}>
      <Form.Group>
        <Form.Label className={styles.txtfom}>Password</Form.Label>
       <InputGroup>
               <Form.Control
                 type={showPassword ? "text" : "password"}
                 placeholder="Enter a strong password"
                 className={styles.txtfield}
                 value={password}
                 onChange={(e) => setPassword(e.target.value)}
                 
               />
       
               <InputGroup.Text
               className={styles.txtfield}
                 onClick={() => setShowPassword(!showPassword)}
                 style={{
                   cursor: "pointer",
                   background: "transparent",
                 }}
               >
                 {showPassword ? <FiEyeOff /> : <FiEye />}
               </InputGroup.Text>
             </InputGroup>
      </Form.Group>
    </Col> */}
 
{/* <p className={styles.otpSub}>
      Forgot Password?
    </p> */}
  

  <Button
    className={styles.signInBtn}
    onClick={handleLogin}
    disabled={loading}
  >
    {loading ? 'Processing your request, please wait...' : "Submit"}
  </Button>
</Form>




        

          

          <p className={styles.signup}>
          Remember your details? <span style={{fontWeight: 600, color: '#059669', cursor: 'pointer'}} onClick={handleRegister}>Login Now</span>
          </p>
        </div>

      </div>
    </div>
  );
};

export default ForgotPassword;
